import type { HTMLAttributes, ReactNode } from 'react';
import { Container } from '../Container/Container';

interface SectionProps extends HTMLAttributes<HTMLElement> {
  /** 'default' = py-20 sm:py-[120px], 'sm' = py-12 sm:py-20, 'lg' = py-[100px] sm:py-[160px] */
  spacing?: 'default' | 'sm' | 'lg' | 'none';
  /** true면 자동으로 Container로 감쌈 */
  contained?: boolean;
  containerWidth?: 'default' | 'narrow' | 'wide' | 'full';
  children: ReactNode;
}

const spacingClass: Record<NonNullable<SectionProps['spacing']>, string> = {
  none: '',
  sm: 'py-12 sm:py-20',
  default: 'py-20 sm:py-[120px]',
  lg: 'py-[100px] sm:py-[160px]',
};

/**
 * 페이지 섹션 공통 wrapper.
 *
 * 사용 예:
 *   <Section contained>...본문...</Section>          // 가운데 max-w 1440
 *   <Section spacing="sm" className="bg-neutral-950">// full-width 배경 + 안쪽 Container 직접
 *     <Container>...</Container>
 *   </Section>
 */
export function Section({
  spacing = 'default',
  contained = false,
  containerWidth = 'default',
  className = '',
  children,
  ...rest
}: SectionProps) {
  const body = contained ? <Container width={containerWidth}>{children}</Container> : children;
  return (
    <section className={`${spacingClass[spacing]} ${className}`} {...rest}>
      {body}
    </section>
  );
}
